import React from 'react'
import Button from '@jarvis.oddle/core/components/Button'
import modalController from 'src/decorators/ModalController'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import { useAppContext } from 'src/containers/AppContext'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import { applyPromotionsAction } from 'src/redux/order/action'

const ProceedToCheckoutButton = ({
  promotions,
  closeCurrentModal,
  text
}: {
  promotions
  closeCurrentModal: (callback) => void
  text?: string
}): JSX.Element => {
  const dispatch = useAppDispatch()
  const { t } = React.useContext(TranslationContext)
  const { prepareToCheckout, redirectToCheckout } = useAppContext()
  const [checkingOut, setCheckingOut] = React.useState(false)

  const redirectToCheckoutPage = () => {
    closeCurrentModal(async () => {
      await prepareToCheckout({
        onReadyToCheckout: (storeOrder) => redirectToCheckout(storeOrder.id),
        onNotReadyToCheckout: (errors, errorCodes) =>
          modalController.showModal('CartErrorModal', { errors, errorCodes })
      })
    })
  }

  const checkout = async () => {
    setCheckingOut(true)
    const promoResponse = await dispatch(applyPromotionsAction({ promotions }))
    if (
      promoResponse.meta.requestStatus === 'fulfilled' &&
      promoResponse?.payload?.payload?.failedPromotions?.length === 0
    ) {
      const failedPromotions =
        promoResponse.payload?.payload?.failedPromotions || []
      const applyPromoCodeSuccess = failedPromotions.length === 0
      if (applyPromoCodeSuccess) {
        redirectToCheckoutPage()
      } else {
        closeCurrentModal(() => {
          modalController.showModal('CheckoutFailedPromotionModal', {
            redirectToCheckoutPage,
            failedPromotions
          })
        })
      }
    } else {
      modalController.showModal('ErrorModal', {
        error: t(promoResponse?.payload?.payload?.failedPromotions?.[0]?.error)
      })
    }
    setCheckingOut(false)
  }

  return (
    <Button
      fullWidth
      disabled={checkingOut}
      loading={checkingOut}
      onClick={checkout}
    >
      {text || t('Proceed to Checkout')}
    </Button>
  )
}

export default ProceedToCheckoutButton
